import Flickity from "flickity";

class CustomFlickity {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-custom-flickity="scope"]',
            button: '[data-flickity-button]',
            dot: '[data-flickity-dot]',
            templatedot: '[data-flickity-dot="template"]'
        }, config);

        this.$scope = $(this.config.scope);

        this.init();
    }

    init() {

        $('.partner_tabs .flickity-carousel').on('change.flickity', (event, index) => {
            let $slider = $(event.currentTarget);

            let secondSlider = null;
            if($slider.data('as-nav-for')) {
                secondSlider = Flickity.data($($slider.data('as-nav-for'))[0]);
                secondSlider.select(index);
            }
        })

        if (this.$scope.length > 0) {
            this.addEventListeners();
            this.initDots();
        }
    }

    addEventListeners() {
        $(document).off('.cflickity')
            .on('click.cflickity', this.config.button, this.changeSlide.bind(this))
            .on('click.cflikcity', this.config.dot, this.changeSlideByDot.bind(this));

		this.$scope.each((index, element) => {
			let $flickity = $(element).find('.flickity-carousel');
			let slider = Flickity.data($flickity[0]);
			slider.on('change', this.changeDot.bind(this, $flickity));
		})

        $(window).resize(() => {
            this.timeout ? clearTimeout(this.timeout) : null;
            this.timeout = setTimeout(() => {
                this.initDots();
            }, 200);
        })

    }

    changeSlide(event) {
        event.preventDefault();
        let $button = $(event.currentTarget);
        let $scope = $button.closest(this.config.scope);
        let $slider = $scope.find('.flickity-carousel');
        let slider = Flickity.data($slider[0]);
        let secondSlider = null;

        if($slider.data('as-nav-for')) {
            secondSlider = Flickity.data($($slider.data('as-nav-for'))[0]);
        }

        if ($button.data('flickity-button') == 'next') {
            slider.next();
            if(secondSlider) {
                secondSlider.next()
            }
        } else {
            slider.previous();
            if(secondSlider) {
                secondSlider.previous()
            }
        }
    }

	changeSlideByDot(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
        let $slider = $scope.find('.flickity-carousel');
        let slider = Flickity.data($slider[0])
        let secondSlider = null;
        if($slider.data('as-nav-for')) {
            secondSlider = Flickity.data($($slider.data('as-nav-for'))[0]);
        }
        slider.select($button.data('flickity-dot'));
        if(secondSlider) {
            secondSlider.select($button.data('flickity-dot'));
        }
	}

    initDots() {
        this.$scope.each((index, element) => {
            let $scope = $(element);
            $scope.find(this.config.dot + '[data-keep="false"]').remove();
            let slider = Flickity.data(($scope.find('.flickity-carousel'))[0])
            let $template = $scope.find(this.config.templatedot);
            let $dots = $scope.find('.dots');
            for (let i = 0; i < slider.slides.length; i++) {
                let $dot = $template.clone();
                if (i == slider.selectedIndex) {
                    $dot.addClass('active');
                }
                $dot.removeClass('d-none');
                $dot.data('flickity-dot', i);
                $dot.attr('flickity-dot', i);
                $dot.attr('data-keep', 'false');
                $dots.append($dot);
            }
        });

    }

    changeDot($flickity, index) {
		let $scope = $flickity.closest(this.config.scope);
        let slider = Flickity.data(($scope.find('.flickity-carousel'))[0])
		$scope.find(this.config.dot).removeClass('active');
        $scope.find(`${this.config.dot}[flickity-dot="${index}"]`).addClass('active');
    }
}

export default CustomFlickity;

